import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
import { TLocale } from '../translations';
import Cookies from 'js-cookie';
import { COOKIES_KEYS } from '../app-constants/constants';

const initialState: TLocale = 'ar';

export const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    changLang: (state, { payload: { lang } }) => {
      document.documentElement.lang = lang;
      document.documentElement.dir = lang;
      localStorage.setItem('lang', lang);
      Cookies.set(COOKIES_KEYS.LanguageAdded, lang);
      return lang;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changLang } = langSlice.actions;

export const getLangState = (state: RootState) => state.lang;

export default langSlice.reducer;
